import { BET_TYPE_LIST } from './BETTYPEDATA';

export default parentType => {
  return BET_TYPE_LIST[parentType];
};



// WEBPACK FOOTER //
// ./src/helpers/getBetType.js